<template>
  <div>
    <Title :pages="[{ icon: 'cogs', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <v-row v-if="list_access">
        <v-col cols="4" md="4" sm="12">
          <v-card class="mx-auto" tile>
            <v-list>
              <v-subheader class="mt-3" style="font-size: 16px">Configuración</v-subheader>
              <v-divider></v-divider>
              <v-list-item-group v-model="selectedItem" color="primary" mandatory>
                <v-list-item v-for="(item, i) in filteredItems" :key="i">
                  <v-list-item-icon>
                    <font-awesome-icon :icon="item.icon" />
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.text"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list> </v-card
        ></v-col>
        <v-col cols="8" md="8" sm="12">
          <v-card class="mx-auto" tile>
            <MiEmpresa v-if="selectedItem == 0" :mainItem="mainItem" @createItem="createItem" :loading="loading_submit" />
            <Facturacion v-if="selectedItem == 1" :mainItem="mainItem" @createItem="createItem" :loading="loading_submit" />
            <Gastos v-if="selectedItem == 2" :mainItem="mainItem" @createItem="createItem" :loading="loading_submit" />
            <Email v-if="selectedItem == 3" :mainItem="mainItem" @createItem="createItem" :loading="loading_submit" :service="service" />
            <Stock v-if="selectedItem == 4" :mainItem="mainItem" @createItem="createItem" :loading="loading_submit" />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import GenericMixin from "@/mixins/GenericMixin.vue";
import SettingsMixin from "@/mixins/SettingsMixin.vue";
import { settingsService } from "@/libs/ws/settingsService";
import Title from "@/components/Title.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import MiEmpresa from "./MiEmpresa.vue";
import Facturacion from "./Facturacion.vue";
import Email from "./Email.vue";
import Stock from "./Stock.vue";
import Gastos from "./Gastos.vue";
import { NonFullScreenPageMode } from "pdf-lib";
export default {
  components: { Title, MiEmpresa, Facturacion, Email, Stock, Gastos },
  mixins: [GenericMixin, RolMixin, SettingsMixin],
  data() {
    return {
      page_title: "Configuración",
      selectedItem: 0,
      service: settingsService,
      items: [
        { text: "Mi empresa", icon: "user" },
        { text: "Facturacíon", icon: "cash-register" },
        { text: "Gastos", icon: "file-invoice" },
        { text: "Email", icon: "envelope" },
        { text: "Stock", icon: "boxes", onlyProducts: true },
      ],
      mainItem: {
        id: 0,
        logo_url: null,
        image_upload: null,
        business_name: "",
        email_sender: "",
        email_sender_name: "",
        preload_last_voucher: true,
        business_type: 1,
        email_host: "",
        email_port: "",
        email_username: "",
        email_password: "",
        email_encryption: null,
        config_email: false,
        stock_by_document: false,
        stock_by_document_start_date: null,
        require_payment_order_for_payment: false,
        require_purchase_order_for_spent: false,
        authorize_purchase_order: false,
        allow_iva_voucher_x: true,
        signature_image_url: null,
        signature_image_upload: null,
        signature_observation: "",
      },
      defaultItem: null,
    };
  },
  computed: {
    filteredItems() {
      // Si es empresa de Productos (business_type == "1"), mostrar todas las opciones
      // Si es empresa de Servicios (business_type == "0"), ocultar la opción Stock
      if (this.mainItem.business_type == "1") {
        return this.items;
      } else {
        return this.items.filter(item => !item.onlyProducts);
      }
    }
  },
  mounted() {
    this.defaultItem = JSON.parse(JSON.stringify(this.mainItem));
    this.loadList(this.service);
  },
  methods: {
    loadList(service, param = null) {
      this.loading = true;

      if (param == null) {
        param = this.getFilterParams();
      }

      this.open_filter = false;
      service
        .filter(param)
        .then((response) => {
          this.mainItem = response.result;
          localStorage.setItem("settings", JSON.stringify(response.result));

          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    createItem(e) {
      this.$validator.validate().then((valid) => {
        if (valid) {
          e.preventDefault();

          let formData = new FormData();
          if (this.mainItem.image_upload != null) formData.append("logo", this.mainItem.image_upload);

          formData.append("id", this.mainItem.id);
          formData.append("business_name", this.mainItem.business_name);
          formData.append("email_sender", this.mainItem.email_sender);
          formData.append("business_type", this.mainItem.business_type);
          formData.append("email_sender_name", this.mainItem.email_sender_name);
          if (this.mainItem.email_host != null) formData.append("email_host", this.mainItem.email_host);
          if (this.mainItem.email_port != null) formData.append("email_port", this.mainItem.email_port);
          if (this.mainItem.email_username != null) formData.append("email_username", this.mainItem.email_username);
          if (this.mainItem.email_password != null) formData.append("email_password", this.mainItem.email_password);
          if (this.mainItem.email_password != null) formData.append("email_encryption", this.mainItem.email_encryption.name);

          formData.append("preload_last_voucher", this.mainItem.preload_last_voucher ? 1 : 0);
          formData.append("hide_logo_non_afip", this.mainItem.hide_logo_non_afip ? 1 : 0);
          formData.append("config_email", this.mainItem.config_email ? 1 : 0);
          if (this.mainItem.billing_legend != null) formData.append("billing_legend", this.mainItem.billing_legend);

          formData.append("stock_by_document", this.mainItem.stock_by_document ? 1 : 0);
          if (this.mainItem.stock_by_document_start_date != null) formData.append("stock_by_document_start_date", this.mainItem.stock_by_document_start_date);

          formData.append("require_payment_order_for_payment", this.mainItem.require_payment_order_for_payment ? 1 : 0);
          formData.append("require_purchase_order_for_spent", this.mainItem.require_purchase_order_for_spent ? 1 : 0);
          formData.append("authorize_purchase_order", this.mainItem.authorize_purchase_order ? 1 : 0);
          formData.append("allow_iva_voucher_x", this.mainItem.allow_iva_voucher_x ? 1 : 0);
          if (this.mainItem.signature_image_upload != null) formData.append("signature_image", this.mainItem.signature_image_upload);
          if (this.mainItem.signature_observation != null) formData.append("signature_observation", this.mainItem.signature_observation);

          this.loading_submit = true;

          this.service
            .update(formData)
            .then((response) => {
              if (response.status == true) {
                this.$toast.success("La configuración se guardo correctamente.", "OK");
                this.updateSettings(true);
                this.$emit("loadList");
              } else {
                if (Object.prototype.hasOwnProperty.call(response, "message")) {
                  this.$toast.error(response.message, "Error");
                } else {
                  this.$toast.error(response.msg, "Error");
                }
              }
              this.loading_submit = false;
            })
            .catch((response) => {
              this.$toast.error(response.msg, "Error");
              this.loading_submit = false;
            });
        } else {
          let msg = "";
          this.errors.items.forEach((e) => {
            msg += e.msg + "\n";
          });
          this.$toast.error(msg, "Error");
        }
      });
    },
  },
};
</script>
